module.exports = ".photo-for-list-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .photo-for-list-form mat-form-field {\n    width: calc(100% - 120px); }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-photo-for-list-form/product-photo-for-list-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-photo-for-list-form/product-photo-for-list-form.component.scss
// module chunks = main